<template>
  <div
    class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]"
  >
    <div class="w-full text-[#414141] font-sans">
      <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">
        Ways to Give
      </h3>
      <div v-if="isLoading" class="text-gray-600 font-sans py-4">
        <p>Loading data...</p>
      </div>
      <div
        v-else-if="!authStore.user?.organization_id"
        class="p-4 bg-yellow-50 font-sans border border-yellow-200 rounded-md mb-4"
      >
        <p class="text-amber-700">Unable to load organization data. Please try refreshing the page.</p>
        <button
          @click="authStore.fetchUserData"
          class="bg-amber-600 font-sans text-white px-4 py-1 rounded-md mt-2"
        >
          Retry Loading Organization Data
        </button>
      </div>
      <div v-else>
        <div class="w-full">
          <div class="overflow-auto pb-16 scroll-smooth" ref="stepWindow">
            <p class="text-[#414141] font-sans text-[14px] leading-[22px] mb-[0.5rem]">
              {{ questionText }}
            </p>

            <div class="mt-0">
              <div
                v-for="(option, idx) in wayOptions"
                :key="idx"
                class="mt-5 ml-4 lg:ml-8"
              >
                <input
                  type="checkbox"
                  class="hidden"
                  :id="`allWays-${idx}`"
                  v-model="option.isSelected"
                />
                <label
                  v-if="!option?.subOption?.length"
                  :for="`allWays-${idx}`"
                  class="cursor-pointer flex items-start gap-2 w-fit"
                >
                  <svg
                    v-if="option.isSelected"
                    class="h-5 w-5 lg:w-6 lg:h-6"
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_1898_29408"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="48"
                      height="48"
                    >
                      <rect width="48" height="48" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_1898_29408)">
                      <path
                        d="M9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.2 6.3 7.5 6.9 6.9C7.5 6.3 8.2 6 9 6H39C39.8 6 40.5 6.3 41.1 6.9C41.7 7.5 42 8.2 42 9V39C42 39.8 41.7 40.5 41.1 41.1C40.5 41.7 39.8 42 39 42H9ZM20.95 31.35C21.15 31.35 21.3417 31.3167 21.525 31.25C21.7083 31.1833 21.8667 31.0667 22 30.9L34.35 18.5C34.65 18.2 34.8 17.85 34.8 17.45C34.8 17.05 34.65 16.6833 34.35 16.35C34.05 16.0833 33.6917 15.95 33.275 15.95C32.8583 15.95 32.5 16.1 32.2 16.4L20.95 27.65L16.05 22.75C15.75 22.45 15.4 22.3 15 22.3C14.6 22.3 14.25 22.45 13.95 22.75C13.65 23.05 13.5 23.4167 13.5 23.85C13.5 24.2833 13.65 24.6333 13.95 24.9L19.9 30.9C20.0667 31.0667 20.2417 31.1833 20.425 31.25C20.6083 31.3167 20.7833 31.35 20.95 31.35Z"
                        class="fill-primary-400"
                      />
                    </g>
                  </svg>
                  <svg
                    v-else
                    class="h-5 w-5 lg:w-6 lg:h-6"
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_1898_29384"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="48"
                      height="48"
                    >
                      <rect width="48" height="48" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_1898_29384)">
                      <path
                        d="M9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.2 6.3 7.5 6.9 6.9C7.5 6.3 8.2 6 9 6H39C39.8 6 40.5 6.3 41.1 6.9C41.7 7.5 42 8.2 42 9V39C42 39.8 41.7 40.5 41.1 41.1C40.5 41.7 39.8 42 39 42H9ZM9 39H39V9H9V39Z"
                        class="fill-primary-400"
                      />
                    </g>
                  </svg>

                  <p class="uppercase text-primary-400 font-archivo font-semibold lg:text-lg">
                    {{ option.label }}
                  </p>
                </label>
                <div v-if="option?.subOption?.length">
                  <h3 class="font-archivo font-medium text-xl text-primary-400 lg:text-2xl">
                    {{ option.label }}
                  </h3>

                  <div
                    v-for="(subOption, index) in option.subOption"
                    :key="index"
                    class="mt-5 ml-4 lg:ml-8"
                  >
                    <input
                      type="checkbox"
                      class="hidden"
                      :id="`allWays-${idx}-${index}`"
                      v-model="subOption.isSelected"
                    />
                    <label
                      :for="`allWays-${idx}-${index}`"
                      class="cursor-pointer flex items-start gap-2 w-fit"
                    >
                      <svg
                        v-if="subOption.isSelected"
                        class="h-5 w-5 lg:w-6 lg:h-6"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_1898_29408"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="48"
                          height="48"
                        >
                          <rect width="48" height="48" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_1898_29408)">
                          <path
                            d="M9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.2 6.3 7.5 6.9 6.9C7.5 6.3 8.2 6 9 6H39C39.8 6 40.5 6.3 41.1 6.9C41.7 7.5 42 8.2 42 9V39C42 39.8 41.7 40.5 41.1 41.1C40.5 41.7 39.8 42 39 42H9ZM20.95 31.35C21.15 31.35 21.3417 31.3167 21.525 31.25C21.7083 31.1833 21.8667 31.0667 22 30.9L34.35 18.5C34.65 18.2 34.8 17.85 34.8 17.45C34.8 17.05 34.65 16.6833 34.35 16.35C34.05 16.0833 33.6917 15.95 33.275 15.95C32.8583 15.95 32.5 16.1 32.2 16.4L20.95 27.65L16.05 22.75C15.75 22.45 15.4 22.3 15 22.3C14.6 22.3 14.25 22.45 13.95 22.75C13.65 23.05 13.5 23.4167 13.5 23.85C13.5 24.2833 13.65 24.6333 13.95 24.9L19.9 30.9C20.0667 31.0667 20.2417 31.1833 20.425 31.25C20.6083 31.3167 20.7833 31.35 20.95 31.35Z"
                            class="fill-primary-400"
                          />
                        </g>
                      </svg>
                      <svg
                        v-else
                        class="h-5 w-5 lg:w-6 lg:h-6"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_1898_29384"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="48"
                          height="48"
                        >
                          <rect width="48" height="48" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_1898_29384)">
                          <path
                            d="M9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.2 6.3 7.5 6.9 6.9C7.5 6.3 8.2 6 9 6H39C39.8 6 40.5 6.3 41.1 6.9C41.7 7.5 42 8.2 42 9V39C42 39.8 41.7 40.5 41.1 41.1C40.5 41.7 39.8 42 39 42H9ZM9 39H39V9H9V39Z"
                            class="fill-primary-400"
                          />
                        </g>
                      </svg>

                      <p class="uppercase text-primary-400 font-archivo font-semibold lg:text-lg">
                        {{ subOption.label }}
                      </p>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="v$.wayOptions.$error" class="mt-4 text-red-500">
              {{ v$.wayOptions.atLeastOne.$message }}
            </div>
            <div v-if="errorMessage" class="mt-4 text-red-500">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import global from "@/global";
import { useStepValidation } from "@/composables/useStepValidation";
const router = useRouter();
const isLoading = ref(true);
const questionText = ref("");
const errorMessage = ref("");
const stepWindow = ref(null);

// Define wayOptions with default values
const wayOptions = ref([
  { label: "Cash", isSelected: false, icon: "money-bill" },
  { label: "Check", isSelected: false, icon: "credit-card" },
  {
    label: "Securities (Stock Transfers)",
    isSelected: false,
    icon: "money-bill-transfer",
  },
  {
    label: "Planned Gifts",
    icon: "gift",
    subOption: [
      {
        label: "Bequests",
        isSelected: false,
        icon: "gift",
      },
      {
        label: "Charitable Gift Annuities",
        isSelected: false,
        icon: "gift",
      },
      {
        label: "Charitable Remainder Trusts/Unitrust",
        isSelected: false,
        icon: "gift",
      },
      {
        label: "Other",
        isSelected: false,
        icon: "gift",
      },
    ],
  },
  { label: "Real Estate", isSelected: false, icon: "building" },
  {
    label: "Other Tangible Property (Art, Automobiles)",
    isSelected: false,
    icon: "shapes",
  },
  { label: "Cryptocurrency", isSelected: false, icon: "coins" },
]);

const lastSavedValue = ref(JSON.stringify(wayOptions.value));

// Define categoryId and questionId as refs
const categoryId = ref("");
const questionId = ref("");

// Validation rules
const rules = {
  wayOptions: {
    atLeastOne: helpers.withMessage(
      "Please select at least one way to give",
      (value) => {
        return value.some(option => 
          option.isSelected || (option.subOption?.some(sub => sub.isSelected))
        );
      }
    )
  }
};

const v$ = useVuelidate(rules, { wayOptions });

// Fetching the auth store
const authStore = useAuthStore();

// Custom validation function for the useStepValidation composable
const validateStep = async () => {
  errorMessage.value = ""; // Clear any previous error messages
  const isValid = await v$.value.$validate();
  
  if (!isValid) {
    return false;
  }

  if (JSON.stringify(wayOptions.value) !== lastSavedValue.value) {
    try {
      await saveUserAnswer();
      return true;
    } catch (error) {
      console.error("Failed to save answer:", error);
      errorMessage.value = "Please ensure your answer is saved before proceeding.";
      return false;
    }
  }

  return true;
};

// Use the step validation composable
useStepValidation({
  initialValidState: false,
  validateFn: validateStep,
});

// Fetching question data directly using fetch API
async function fetchQuestionData() {
  try {
    const res = await fetch(`${global.API_URL}/questions/case_statement_ways_to_give`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authStore.user.accessToken}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    const data = await res.json();
    
    if (!data || !data.question) {
      throw new Error('Invalid response structure from API');
    }

    questionText.value = data.question.title || '';
    categoryId.value = data.question.category_id || '';
    questionId.value = data.question.id || '';

    if (!questionId.value) {
      throw new Error('Question ID is missing from the response');
    }
  } catch (error) {
    console.error('Error fetching question data:', error);
    errorMessage.value = "Failed to load question data. Please try again.";
    isLoading.value = false;
  }
}

// Fetching user answer directly using fetch API
async function getUserAnswer() {
  const organizationId = authStore.user.organization_id;

  if (!organizationId) {
    console.error("Invalid organizationId:", organizationId);
    errorMessage.value = "Invalid organization ID. Please try refreshing the page.";
    return;
  }

  if (!questionId.value) {
    console.error("Invalid questionId:", questionId.value);
    errorMessage.value = "Question ID not available. Please try refreshing the page.";
    return;
  }

  try {
    const res = await fetch(
      `${global.API_URL}/answers?question_id=${questionId.value}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authStore.user.accessToken}`,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    const data = await res.json();
    let answer = data.answer;
    if (answer != null) {
      wayOptions.value = JSON.parse(answer.answer);
      lastSavedValue.value = answer.answer;
    }
  } catch (error) {
    console.error("Failed to fetch user answer:", error);
    errorMessage.value = "Failed to load your previous answer. You can still create a new one.";
  }
}

// Saving user answer directly using fetch API
async function saveUserAnswer() {
  const organizationId = authStore.user.organization_id;

  if (!organizationId) {
    errorMessage.value = "Invalid organization ID. Please try refreshing the page.";
    return false;
  }

  try {
    const res = await fetch(`${global.API_URL}/answers`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authStore.user.accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        category_id: categoryId.value,
        question_id: questionId.value,
        answer: JSON.stringify(wayOptions.value),
      }),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    errorMessage.value = "";
    lastSavedValue.value = JSON.stringify(wayOptions.value);
    return true;
  } catch (error) {
    errorMessage.value = "Failed to save your answer. Please try again.";
    console.error("Failed to save user answer:", error);
    return false;
  }
}

onMounted(async () => {
  try {
    isLoading.value = true;
    errorMessage.value = "";

    await authStore.fetchUserData();

    if (!authStore.user?.organization_id) {
      errorMessage.value = "Unable to load organization data. Please try refreshing the page.";
      console.error("No organization ID available");
      return;
    }

    await fetchQuestionData();

    if (!questionId.value) {
      errorMessage.value = "Unable to load question data. Please try refreshing the page.";
      console.error("No question ID available");
      return;
    }

    await getUserAnswer();

  } catch (error) {
    console.error("Error during component initialization:", error);
    errorMessage.value = "An error occurred while loading the data. Please try refreshing the page.";
  } finally {
    isLoading.value = false;
  }
});
</script>

<style scoped>
.answer-err-enter-active,
.answer-err-leave-active {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.answer-err-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.answer-err-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style> 